// frontend/src/lib/expiryPolicy.js
// Resolve expiry policies with optional country overrides (mirrors backend helper).
import { DOC_EXPIRY_POLICIES } from "../docKinds.js";

export function resolveExpiryPolicy(kind, contextCountry, policies = DOC_EXPIRY_POLICIES) {
  const k = String(kind || "").toLowerCase();
  const country = String(contextCountry || "").toUpperCase();
  const base = policies[k] || {};
  const override = country && base.overrides && base.overrides.byCountry && base.overrides.byCountry[country];
  const merged = { ...(policies._default || {}), ...base, ...(override || {}) };
  delete merged.overrides;
  if (!merged.field) merged.field = "expires_on";
  if (!merged.source) merged.source = "issued_on";
  return merged;
}

export default { resolveExpiryPolicy };
